import { Modifier } from '@dnd-kit/core/dist/modifiers';
import { TaskGroup, TaskItem } from './TasksList.types';

const highestCountItem = (items: TaskItem[]) => {
  return items.reduce((maxItem, curr) => {
    return curr.count > maxItem.count ? curr : maxItem;
  });
};

export const getAllMaxItems = (data: TaskGroup[]) => {
  return data
    .map(({ items, key }) => {
      const itemMax = highestCountItem(items);
      return { ...itemMax, key };
    })
    .filter((item) => item.count > 0);
};

export const restrictToElement = (element: HTMLElement | null): Modifier => {
  return ({ transform, activeNodeRect }) => {
    if (!element || !activeNodeRect) return transform;

    const bounds = element.getBoundingClientRect();

    const x = Math.min(
      Math.max(transform.x, bounds.left - activeNodeRect.left),
      bounds.right - activeNodeRect.right
    );

    const y = Math.min(
      Math.max(transform.y, bounds.top - activeNodeRect.top),
      bounds.bottom - activeNodeRect.bottom
    );

    return { ...transform, x, y };
  };
};
